interface AlmaOrbProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  animated?: boolean;
  /** Optional mood for future use (e.g. calm, curious); does not change visual yet. */
  mood?: string;
}

/** Alma visual orb component with configurable size and optional animation. */
export function AlmaOrb({ className = '', size = 'md', animated = true, mood }: AlmaOrbProps) {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-40 h-40',
  };

  return (
    <div
      className={`relative ${sizeClasses[size]} ${className}`}
      data-mood={mood ?? undefined}
      role="img"
      aria-label="Alma"
    >
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full"
        style={{
          filter: 'drop-shadow(0 4px 12px rgba(19, 68, 115, 0.2))',
        }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="alma-skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#F98866" />
            <stop offset="50%" stopColor="#FDAA63" />
            <stop offset="100%" stopColor="#FDC65B" />
          </linearGradient>
          <linearGradient id="alma-sunGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#FFE08A" />
            <stop offset="100%" stopColor="#FDC65B" />
          </linearGradient>
          <linearGradient id="alma-hillGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1A4B6E" />
            <stop offset="100%" stopColor="#0F365E" />
          </linearGradient>
          <linearGradient id="alma-ringGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1A4B6E" />
            <stop offset="100%" stopColor="#0F365E" />
          </linearGradient>
          <clipPath id="alma-innerCircle">
            <circle cx="50" cy="50" r="42" />
          </clipPath>
        </defs>

        <circle
          cx="50"
          cy="50"
          r="46"
          fill="none"
          stroke="url(#alma-ringGradient)"
          strokeWidth="6"
        />

        <g clipPath="url(#alma-innerCircle)">
          <rect x="0" y="0" width="100" height="100" fill="url(#alma-skyGradient)" />
          <circle
            cx="50"
            cy="52"
            r="18"
            fill="url(#alma-sunGradient)"
            className={animated ? 'animate-breathe' : ''}
            style={{ transformOrigin: '50px 52px' }}
          />
          <ellipse cx="20" cy="95" rx="50" ry="45" fill="url(#alma-hillGradient)" opacity="0.9" />
          <ellipse cx="80" cy="95" rx="50" ry="45" fill="url(#alma-hillGradient)" opacity="0.9" />
          <ellipse cx="50" cy="105" rx="55" ry="40" fill="#1A4B6E" />
        </g>
      </svg>
    </div>
  );
}
